// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"Button_resetButton__EFynh"};